<template>
    <validation-provider
        v-slot="{ errors }"
        :name="label || 'This'"
        :rules="rules"
        v-bind="providerProps"
        v-show="innerShouldShow"
        :vid="'validate-' + fieldAssignmentId"
    >
        <v-text-field
            v-model="innerValue"
            v-bind="vProps"
            :ref="vProps.vid"
            :error-messages="errors"
            :prepend-icon="computedIcon"
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            :type="showPassword ? 'text' : 'password'"
            @click:append="showPassword = !showPassword"
        >
            <template #label>
                <span v-html="innerLabel"></span>
            </template>
        </v-text-field>
        <small v-if="showForgetLink" class="pb-3 d-block text-right"
            ><a href="/password/reset">Forgot your password?</a></small
        >
    </validation-provider>
</template>

<script>
import formMixin from '../formMixin';

export default {
    name: 'TypeTextBox',
    mixins: [formMixin],
    props: {
        showIcon: {
            type: Boolean,
            default: false
        },
        showForgetLink: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            showPassword: false
        };
    },
    mounted() {
        this.fieldLoaded(); // signal to the form we are loaded
    },
    computed: {
        defaults() {
            return {
                label: this.innerLabel,
                persistentHint: true
            };
        },
        rules() {
            return (this.enableValidation) ? {
                ...this.validation_settings,
                ...(this.hasMinLength && {
                    minlength: this.validation_settings.minlength
                }),
                ...(this.hasConfirmPassword && {
                    'confirm-password': this.validation_settings[
                        'confirm-password'
                    ]
                })
            } : {};
        },
        computedIcon() {
            return this.showIcon ? 'mdi-lock' : undefined;
        },
        hasMinLength() {
            if (typeof this.validation_settings === 'object') {
                return Object.hasOwnProperty.call(
                    this.validation_settings,
                    'minlength'
                );
            }

            return false;
        },
        hasConfirmPassword() {
            if (typeof this.validation_settings === 'object') {
                return Object.hasOwnProperty.call(
                    this.validation_settings,
                    'confirm-password'
                );
            }

            return false;
        }
    }
};
</script>
